<template>
	<span v-if="region" class="Region" :classes="classes">
		<a :href="`${baseUrl}region/${region.code}`" class="Region-link">{{ region.name }}</a>
		<a v-if="showFullName && parent" :href="`${baseUrl}region/${parent.code}`" class="Region-link">{{ parent.name }}</a>
		<a v-if="showFullName && grandparent" :href="`${baseUrl}region/${grandparent.code}`" class="Region-link">{{ grandparent.name }}</a>
		<span v-if="!compact && region.subregions" class="Region-sub">
			({{ region.subregions.length
			}}<span v-if="showSubregionsLabel" class="Region-sub-label"> {{ $t('hsinfo.sideBarItem_country_desc') }}</span
			>)</span
		>
	</span>
</template>

<script>
export default {
	name: 'Region',
	components: {},
	props: {
		region: Object,
		parent: Object,
		grandparent: Object,
		compact: Boolean,
		showSubregionsLabel: Boolean,
		showFullName: Boolean,
	},
	computed: {
		classes() {
			const classes = {
				'Region--fullName': this.showFullName,
			};
			return classes;
		},
	},
	data() {
		return {
			baseUrl: window.baseUrl,
		};
	},
};
</script>

<style lang="scss">
.Region {
	color: var(--color-text-muted);
	display: inline-flex;
	flex-wrap: wrap;
	align-items: baseline;
	column-gap: $space-rel-sm;
	.Region-sub .Region-sub {
		font-weight: normal;
	}
	.Region-link:not(:last-of-type):after {
		color: var(--color-text-muted);
		opacity: 0.5;
		content: ',';
	}
}
</style>
